import { render, staticRenderFns } from "./AthleteModal.vue?vue&type=template&id=5ea9bbec&scoped=true&"
import script from "./AthleteModal.vue?vue&type=script&lang=js&"
export * from "./AthleteModal.vue?vue&type=script&lang=js&"
import style0 from "./AthleteModal.vue?vue&type=style&index=0&id=5ea9bbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9bbec",
  null
  
)

export default component.exports